(function () {
  if (window.__uniScrollRevealInit) return;
  window.__uniScrollRevealInit = true;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer;

  function reveal(el) {
    el.classList.add('is-revealed');
    if (observer) observer.unobserve(el);
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var margin = 60;
    return rect.top < window.innerHeight + margin && rect.bottom > -margin;
  }

  function revealVisible() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach(function (el) {
      if (isInViewport(el)) reveal(el);
    });
  }

  function observeItems(items) {
    if (!observer) return;
    items.forEach(function (el) {
      if (!el.classList.contains('is-revealed')) observer.observe(el);
    });
  }

  function init() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          reveal(entry.target);
        });
      },
      {
        threshold: 0.15,
        rootMargin: '0px 0px 60px 0px'
      }
    );

    observeItems(items);

    window.setTimeout(revealVisible, 1200);

    var scrollTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(function () {
          revealVisible();
          scrollTicking = false;
        });
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
